import customerImage1 from 'assets/images/customer-images/customer-image1.png';
import customerImage2 from 'assets/images/customer-images/customer-image2.png';
import customerImage3 from 'assets/images/customer-images/customer-image3.png';
import customerImage4 from 'assets/images/customer-images/customer-image4.png';

const TrustPilotReviews = [
	{
		id: '1',
		title: 'Easy to use and save money',
		text: 'The site was easy to use, and I found a storage unit near me with an online price that was less than the storage facility itself. The site walked me through everything I needed to do, and it exceeded my expectations. I was able to complete my booking in a short amount of time. ',
		stars: 5,
		customerName: 'Cheryl Slavinsky ',
		key: 'Cheryl Slavinsky ',
		customerImage: customerImage1,
	},
	{
		id: '2',
		title: 'How easy it was!',
		text: 'How easy it was! It was so easy to rent a unit. Everything was simple and easy. It’s hard enough moving so it was less stressful with how easy they made it to rent a storage unit. ',
		stars: 5,
		customerName: 'Bonnie Ulrick',
		key: 'Bonnie Ulrick',
		customerImage: customerImage2,
	},
	{
		id: '3',
		title: 'The online reservation and rental were so easy and fast',
		text: 'I received confirmation and access code within minutes for a rental starting the following day. I also received emails and reminders when my unit was ready. ',
		stars: 5,
		customerName: 'Mike McGraw',
		key: 'Mike McGraw',
		customerImage: customerImage3,
	},
	{
		id: '4',
		title: 'I just made a reservation by phone',
		text: 'What a wonderful experience it was! Customer service was so patient with me, made sure I was choosing the closest place to my home, and looked for deals. ',
		stars: 5,
		customerName: 'Lynn San',
		key: 'Lynn San',
		customerImage: customerImage4,
	},
];

export default TrustPilotReviews;
